import { useCallback, useEffect, useState } from 'react';

const useCopyToClipboard = (
  text: string,
  inputRef: React.RefObject<HTMLInputElement & HTMLTextAreaElement>,
) => {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(() => {
    const copyToClipboard = (ref: React.RefObject<HTMLInputElement & HTMLTextAreaElement>) => {
      ref?.current?.select();
      const success = document.execCommand('copy');
      return success;
    };

    setCopied(copyToClipboard(inputRef));
  }, [inputRef]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Refresh copied state on text update
  useEffect(() => () => setCopied(false), [text]);

  const resetCopy = useCallback(() => {
    setCopied(false);
  }, []);

  return [copied, copy, resetCopy] as const;
};

export default useCopyToClipboard;
